import { parseContentDispositionFilename } from "./downloadBlob";

export type CsvDownloadResponse = { status: 200; blob: Blob; filename: string };
export type CsvExportResponse = CsvDownloadResponse | { status: 202 } | { status: 204 };

export const readCsvResponse = async (response: Response): Promise<unknown> => {
  if (response.status === 204) return { status: 204 };
  if (response.status === 202) return { status: 202 };
  const contentType = response.headers.get("Content-Type") ?? "";
  if (response.status !== 200 || !contentType.includes("text/csv")) {
    return contentType.includes("json") ? response.json() : { message: "No se pudo descargar el CSV" };
  }
  return {
    status: 200,
    blob: await response.blob(),
    filename: parseContentDispositionFilename(response.headers.get("Content-Disposition")) ?? "export.csv",
  };
};

export const isCsvDownloadResponse = (response: Response): boolean =>
  response.status === 200 && (response.headers.get("Content-Type") ?? "").includes("text/csv");
